import enums from 'utilities/enums';
const { NOTIFICATION_TYPES } = enums;

export const NOTIFICATION_SETTINGS_TITLE_BASED_ON_TYPE = {
  [NOTIFICATION_TYPES.ENTITY_CREATED]: 'An Entity Has Been Created',
  [NOTIFICATION_TYPES.CASE_CREATED]: 'A Case Has Been Created',
  [NOTIFICATION_TYPES.ENTITY_ASSIGNED]: 'An Entity Has Been Assigned to You',
  [NOTIFICATION_TYPES.CASE_ASSIGNED]: 'A Case Has Been Assigned to You',
  [NOTIFICATION_TYPES.RCU_RECEIVED]: 'An RCU Request Has Been Received ',
  [NOTIFICATION_TYPES.KYC_REFRESH_ARRIVED]: 'A KYC Refresh Date Has Arrived ',
  [NOTIFICATION_TYPES.ENTITY_ASSIGNED_NEW_ISSUE]: 'An Entity Assigned to You Has a New Issue',
  [NOTIFICATION_TYPES.CASE_ASSIGNED_OM_ISSUE]: 'A Case Assigned to You Has a New Issue',
  [NOTIFICATION_TYPES.OM_EXPIRED]: 'Ongoing Monitoring Has Expired for a Case Assigned to You',
  [NOTIFICATION_TYPES.MENTION_IN_COMMENT]: 'A Team Member Mentioned You in a Comment',
  [NOTIFICATION_TYPES.ENTITY_DELETED]: 'An Entity Has Been Deleted /Ask to Approve or Reject Deletion of X',
  [NOTIFICATION_TYPES.CASE_DELETED]: 'A Case Has Been Deleted /Ask to Approve or Reject Deletion of X',
  [NOTIFICATION_TYPES.OM_EXPIRING]: 'Ongoing Monitoring Expiry Reminder',
};
